import dynamic from "next/dynamic";

const AboutCreator = dynamic(() => import("./AboutCreator"));
const AboutEvent = dynamic(() => import("./AboutEvent"));
const AboutPlan = dynamic(() => import("./AboutPlan"));
const AddressInfo = dynamic(() => import("./AddressInfo"));
const ContentHeader = dynamic(() => import("./ContentHeader"));
const CourseDetails = dynamic(() => import("./CourseDetails"));
const CreatorFAQ = dynamic(() => import("./CreatorFAQ"));
/* discount */
const DiscountField = dynamic(() => import("./Discount/DiscountField"));
const LoyaltyDiscountsPopup = dynamic(
    () => import("./Discount/LoyaltyDiscountsPopup")
);
const LoyaltyDiscountsSection = dynamic(
    () => import("./Discount/LoyaltyDiscountsSection")
);
/* discount */
const EventMedia = dynamic(() => import("./EventMedia"));
const RecentSalesPopup = dynamic(() => import("./RecentSalesPopup"));
const Reviews = dynamic(() => import("./Reviews"));
const OfferPromotion = dynamic(() => import("./OfferPromotion"));

export {
    AboutCreator,
    AboutEvent,
    AboutPlan,
    AddressInfo,
    ContentHeader,
    CourseDetails,
    CreatorFAQ,
    /* discount */
    DiscountField,
    LoyaltyDiscountsPopup,
    LoyaltyDiscountsSection,
    OfferPromotion,
    /* discount */
    EventMedia,
    RecentSalesPopup,
    Reviews,
};
